import { b as _defineProperty, _ as _getPrototypeOf, a as _possibleConstructorReturn, c as _inherits, d as _classCallCheck, e as _createClass, Q } from '../_chunks/dep-b05afc19.js';
import { IconBase } from '../icon.js';
import '../util/classname.js';
import '../util/size-props.js';
import '../util/check-url-and-load.js';

var _class;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
var element = {
  "attributes": {
    "fill": "none",
    "viewBox": "0 0 24 24",
    "width": "1em",
    "height": "1em"
  },
  "nodeName": "svg",
  "children": [{
    "attributes": {
      "id": "delete"
    },
    "nodeName": "g",
    "children": [{
      "attributes": {
        "id": "fill1",
        "fill": "transparent",
        "d": "M5 5H19L18.5 22H5.5L5 5Z"
      },
      "nodeName": "path",
      "children": []
    }, {
      "attributes": {
        "id": "stroke1",
        "stroke": "currentColor",
        "d": "M21 5H3M5 5H19L18.5 22H5.5L5 5ZM8.5 2H15.5V5H8.5V2Z",
        "stroke-linecap": "square",
        "stroke-width": 2
      },
      "nodeName": "path",
      "children": []
    }, {
      "attributes": {
        "id": "stroke2",
        "stroke": "currentColor",
        "d": "M12 9V18",
        "stroke-linecap": "square",
        "stroke-width": 2
      },
      "nodeName": "path",
      "children": []
    }]
  }]
};
var DeleteIcon = (_class = /*#__PURE__*/function (_IconBase) {
  _inherits(DeleteIcon, _IconBase);
  var _super = _createSuper(DeleteIcon);
  function DeleteIcon() {
    var _this;
    _classCallCheck(this, DeleteIcon);
    _this = _super.call(this);
    _this.props = _objectSpread(_objectSpread({}, _this.props), {}, {
      id: "delete"
    });
    return _this;
  }
  return _createClass(DeleteIcon);
}(IconBase), _defineProperty(_class, "icon", element), _class);
DeleteIcon = __decorateClass([Q("t-icon-delete")], DeleteIcon);

export default DeleteIcon;
//# sourceMappingURL=delete.js.map
